"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import { useDesktopAnimations } from "@/lib/breakpoints";
import { FaChevronRight } from "react-icons/fa";
import GradientButton from "@/components/ui/GradientButton";
import ProcessSteps, { ProcessStepItem } from "@/components/common/ProcessSteps";
interface LaravelWhyChooseProps {
  imageSrc?: string;
  imageAlt?: string;
}
export default function LaravelWhyChoose(t0) {
  const $ = _c(18);
  const {
    imageSrc: t1,
    imageAlt: t2
  } = t0;
  const imageSrc = t1 === undefined ? "/images/laravel/laravel-best-choice.png" : t1;
  const imageAlt = t2 === undefined ? "What Makes The Dezine Your Best Choice for Laravel Developers?" : t2;
  const desktopAnimations = useDesktopAnimations();
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [{
      id: "constant-reports",
      title: "Constant Reports",
      description: "We know how important your project is for you. So, we keep you updated with regular reports.",
      icon: "/images/laravel/h-icon-1.svg"
    }, {
      id: "save-cost",
      title: "Save infrastructure cost",
      description: "Our app development plans easily fit your budget requirements.",
      icon: "/images/laravel/infrastructure-cost.png"
    }, {
      id: "on-time-deliveries",
      title: "On-Time Deliveries",
      description: "Our top Laravel developers always deliver projects on time. We stick to committed deadlines.",
      icon: "/images/laravel/on-time-deliveries.png"
    }, {
      id: "technical-sound",
      title: "Technical Sound",
      description: "Hire certified Laravel programmers who are adept with the latest Laravel frameworks and libraries at flexible costs.",
      icon: "/images/laravel/technical-sound.png"
    }, {
      id: "fast-onboarding",
      title: "Fast onboarding",
      description: "Our hiring process is short to help our clients hire Laravel engineers quickly.",
      icon: "/images/flutter/deployment.png"
    }, {
      id: "quality-service",
      title: "Quality & Service",
      description: "We have a track of delivering high-quality Laravel development services developed by our Laravel experts.",
      icon: "/images/laravel/quality-service.png"
    }];
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const items = t3;
  let t4;
  if ($[1] !== desktopAnimations) {
    t4 = desktopAnimations ? {
      y: [0, -8, 0]
    } : undefined;
    $[1] = desktopAnimations;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== desktopAnimations) {
    t5 = desktopAnimations ? {
      duration: 3.5,
      repeat: Infinity,
      ease: "easeInOut"
    } : undefined;
    $[3] = desktopAnimations;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="inline-flex items-center justify-center dark:rounded-full dark:bg-white dark:px-4 dark:py-1.5 dark:shadow-[0_2px_15px_rgba(255,255,255,0.12)]"><Image src="/images/laravel/experts.png" alt="Laravel Experts" width={220} height={48} loading="lazy" className="h-10 sm:h-12 w-auto max-w-[220px] object-contain dark:h-8 dark:max-w-[180px] dark:sm:h-9" onError={_temp} /></div>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t4 || $[7] !== t5) {
    t7 = <motion.div animate={t4} transition={t5} className="mb-4 flex items-center justify-start">{t6}</motion.div>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="font-poppins text-[28px] font-bold leading-[1.25] text-[#0b1354] sm:text-[36px] lg:text-[42px] dark:text-white">What Makes The Dezine Your Best Choice for Laravel Developers?</span>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t7) {
    t9 = <div>{t7}{t8}</div>;
    $[10] = t7;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <p className="mt-4 font-sans text-[15px] font-normal leading-[1.7] text-[#66698a] sm:text-[16px] dark:text-gray-300">Get a talent edge for your in-house team or business by hiring the top 1% of talented Laravel coders.</p>;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <>{t10}<div className="mt-6 mb-2"><GradientButton href="/contact" variant="pink-purple" className="max-w-[calc(100vw-32px)] sm:max-w-none !px-5 sm:!px-8 !text-[14px] sm:!text-[16px]"><span>Hire Top Talent Now!</span><FaChevronRight className="ml-1 text-[11px] sm:text-[12px] shrink-0" /></GradientButton></div></>;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== imageAlt || $[15] !== imageSrc || $[16] !== t9) {
    t12 = <div className="relative"><ProcessSteps heading={t9} headingContent={t11} image={imageSrc} imageAlt={imageAlt} items={items} numbered={false} sticky={true} /></div>;
    $[14] = imageAlt;
    $[15] = imageSrc;
    $[16] = t9;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  return t12;
}
function _temp(e) {
  e.currentTarget.src = "/images/shopify/shopify-exprets.png";
}